const isJson = (str: string) => {
  try {
    JSON.parse(str);
  } catch (err) {
    return false;
  }

  return true;
};

export const getFromLocalStorage = (key: string) => {
  const stringifyValue = localStorage.getItem(key);
  if (stringifyValue && isJson(stringifyValue)) return JSON.parse(stringifyValue).value;
  else return stringifyValue;
};

export const putToLocalStorage = ({ key, value }: { key: string, value: any }) => {
  const stringifyValue = JSON.stringify({ value });
  localStorage.setItem(key, stringifyValue);
};

export const deleteFromLocalStorage = (keys: Array<string> | string) => {
  Array.isArray(keys)
    ? keys.forEach(key => localStorage.removeItem(key))
    : localStorage.removeItem(keys);
};
